import { render } from "./LotControlPanelTemplate.vue?vue&type=template&id=b8fa1f14"
import script from "./LotControlPanelTemplate.vue?vue&type=script&lang=js"
export * from "./LotControlPanelTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/lots/fixprice/LotControlPanelTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8fa1f14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8fa1f14', __exports__)) {
    console.log('reload')
    api.reload('b8fa1f14', __exports__)
  }
  
  module.hot.accept("./LotControlPanelTemplate.vue?vue&type=template&id=b8fa1f14", () => {
    console.log('re-render')
    api.rerender('b8fa1f14', render)
  })

}


export default __exports__